import React from 'react';

import {
  Filter, Box, Card, useWindowSize,
} from 'vindi-ds-components';
import tokens from 'vindi-ds-tokens';

import CardsChargesPending from './cards';
import TableChargesPending from './table';
import TableCardChargesPending from './tableCard';
import PageEmptyState from './empty_state';

import useFilterChargesPending from '../hooks/useFilterChargesPending';

const ListComponent = ({ data, isMobile }) => {
  const RootContainer = isMobile ? React.Fragment : Card;
  const RootListing = isMobile ? TableCardChargesPending : TableChargesPending;

  return (
    <RootContainer noShadow>
      <RootListing listingData={data} />
      <Box px={2} pb={3} bgcolor={!isMobile && tokens.color.prsm.neutral['000'].value}>
        <Filter.Pagination />
      </Box>
    </RootContainer>
  );
};

const List = () => {
  const { listing } = useFilterChargesPending();
  const { isLoading, status, data } = listing.query;
  const { isMobile } = useWindowSize();

  if (isLoading || status === 'idle') { return null; }

  return (
    <Filter.FilterProvider {...listing}>
      <Box pb={5}>
        <CardsChargesPending listingData={data} />
      </Box>

      {data.chargesPending?.length ? (
        <ListComponent data={data} isMobile={isMobile} />
      ) : <PageEmptyState />}

    </Filter.FilterProvider>
  );
};

export default List;
